// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api: {
    path: '/rest',
  },
  local_ip: '192.168.100',
  kubehost: 'http://192.168.200.200',
  socket_url: 'http://192.168.100.151:8080',
  ai_classes : ["person" ,"bicycle" ,"motorbike" ,"car" ,"truck" ,"bus" ,
                "aeroplane" ,"train"  ,"boat" ,
                "traffic light" ,"fire hydrant" ,
                "stop sign" ,"parking meter" ,"bench" ,
                "bird" ,"cat" ,"dog" ,"horse" ,"sheep" ,
                "cow" ,"elephant" ,"bear" ,"zebra" ,"giraffe" ,
                "backpack" ,"umbrella" ,"handbag" ,"tie" ,
                "suitcase" ,"frisbee" ,"skis" ,"snowboard" ,
                "sports ball" ,"kite" ,"baseball bat" ,"baseball glove" ,
                "skateboard" ,"surfboard" ,"tennis racket" ,"bottle" ,
                "wine glass" ,"cup" ,"fork" ,"knife" ,"spoon" ,"bowl" ,
                "banana" ,"apple" ,"sandwich" ,"orange" ,"broccoli" ,
                "carrot" ,"hot dog" ,"pizza" ,"donut" ,"cake" ,"chair" ,
                "sofa" ,"potted plant" ,"bed" ,"dining table" ,"toilet" ,
                "tvmonitor" ,"laptop" ,"mouse" ,"remote" ,"keyboard" ,
                "cell phone" ,"microwave" ,"oven" ,"toaster" ,"sink" ,
                "refrigerator" ,"book" ,"clock" ,"vase" ,"scissors" ,
                "teddy bear" ,"hair drier" ,"toothbrush" ]
};   
   